module.exports = __webpack_public_path__ + "img/avatar4.dfe1e662.png";